import {
  TypographyElement
} from 'UI'
import { createUseStyles } from 'react-jss'
import style from './style'

export default ({ review, reviewCount, totalReview, color }) => {
  const useStyle = createUseStyles(style)
  const { group, percentage, rateAndLine, reviewCountPercentage } = useStyle({ reviewCount, totalReview, color })
  return (
    <div className={group}>
      <div className={rateAndLine}>
        <TypographyElement
          variant='body2'
          spacing='0 8px 0 0'
        >
          {review}
        </TypographyElement>
        <div className={percentage} />
      </div>
      <TypographyElement
        variant='body2'
        spacing='0 0 0 8px'
        className={reviewCountPercentage}
      >
        {`${totalReview === 0 ? 0 : Number(((reviewCount / totalReview) * 100).toFixed(1))}%`}
      </TypographyElement>
      <TypographyElement
        variant='body2'
        align='right'
        className={reviewCountPercentage}
      >
        {reviewCount}
      </TypographyElement>
    </div>
  )
}
